import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[stxtImageProtection]',
  standalone: true
})
export class ImageProtectionDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.applyProtectionStyles();
  }

  private applyProtectionStyles(): void {
    const styles = {
      'user-select': 'none',
      '-webkit-user-select': 'none',
      '-moz-user-select': 'none',
      '-ms-user-select': 'none',
      '-webkit-user-drag': 'none'
    };

    Object.entries(styles).forEach(([property, value]) => {
      this.renderer.setStyle(this.el.nativeElement, property, value);
    });
  }

  // Prevent right-click context menu
  @HostListener('contextmenu', ['$event'])
  onContextMenu(event: MouseEvent): boolean {
    event.preventDefault();
    return false;
  }

  // Prevent drag and drop
  @HostListener('dragstart', ['$event'])
  onDragStart(event: DragEvent): boolean {
    event.preventDefault();
    return false;
  }

  // Prevent selection
  @HostListener('selectstart', ['$event'])
  onSelectStart(event: Event): boolean {
    event.preventDefault();
    return false;
  }
}
